<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/79HpdM/tc-custom/Cover.jpg?1680202048160" alt="This image is the cover for the book Pizzeria Kamikaze, Pizzeria Kamikaze"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pizzeria Kamikaze, Pizzeria Kamikaze
      </h1>
      <p class="bookDescription body article font2">
        <p>Presented for the first time in full color, award-winning writer Etgar Keret (The Seven Good Years) and Eisner Award-winning cartoonist Asaf Hanuka’s (The Realist) powerful graphic novel, Pizzeria Kamikaze, is a most unexpected story of love, loss, and escape. Mordy wanted to get away. Now condemned to an afterlife exclusively for all victims of suicide, he still has to attend a crappy job in a place no less crappy than the place he came from. When he discovers that his beloved ex-girlfriend is there too, he embarks on much needed road trip through an absurdist and fantastical landscape to find her.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Etgar Keret, Asaf Hanuka, Dan Jackson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?99781d92